export const SET_FILTERS = 'FILTERS:SET_FILTERS';

export const GET_ORDERS_SUCCESS = 'ORDERS:GET_ORDERS_SUCCESS';
export const GET_ORDERS_FAILURE = 'ORDERS:GET_ORDERS_FAILURE';
export const GET_ORDERS = 'ORDERS:GET_ORDERS';

export const GET_VIEW_DATA = 'ORDERS:GET_VIEW_DATA';
export const GET_VIEW_DATA_SUCCESS = 'ORDERS:GET_VIEW_DATA_SUCCESS';
export const GET_VIEW_DATA_FAILURE = 'ORDERS:GET_VIEW_DATA_FAILURE';
export const SET_VIEW_DATA_EMPTY = 'ORDERS:SET_VIEW_DATA_EMPTY';

export const GET_CARD_DATA = 'ORDERS:GET_CARD_DATA';
export const GET_CARD_DATA_SUCCESS = 'ORDERS:GET_CARD_DATA_SUCCESS';
export const GET_CARD_DATA_FAILURE = 'ORDERS:GET_CARD_DATA_FAILURE';

export const GET_SEARCH_CARD_DATA = 'ORDERS:GET_SEARCH_CARD_DATA';
export const GET_SEARCH_CARD_DATA_SUCCESS =
    'ORDERS:GET_SEARCH_CARD_DATA_SUCCESS';
export const GET_SEARCH_CARD_DATA_FAILURE =
    'ORDERS:GET_SEARCH_CARD_DATA_FAILURE';

export const GET_LIST_DATA = 'ORDERS:GET_LIST_DATA';
export const GET_LIST_DATA_SUCCESS = 'ORDERS:GET_LIST_DATA_SUCCESS';
export const GET_LIST_DATA_FAILURE = 'ORDERS:GET_LIST_DATA_FAILURE';

export const SET_VISIBLE_DATE_RANGE = 'CALENDAR:SET_VISIBLE_DATE_RANGE';
export const SET_SURGERY_DATES = 'CALENDAR:SET_SURGERY_DATES';
export const CALENDAR_VIEW = 'CALENDAR:CALENDAR_VIEW';
export const SET_SELECTED_DATE = 'CALENDAR:SET_SELECTED_DATE';
export const RESET_SELECTED_DATE = 'CALENDAR:RESET_SELECTED_DATE';

export const OPEN_FILTERS = 'FILTERS:OPEN_FILTERS';
export const SET_SELECTED_CALENDAR_VIEW = 'FILTERS:SET_SELECTED_CALENDAR_VIEW';
export const SET_ACTION_ITEMS_ONLY = 'FILTERS:SET_ACTION_ITEMS_ONLY';
export const SET_EXPANDED_FILTER_VIEWS = 'FILTERS:SET_EXPANDED_FILTER_VIEWS';
export const SET_LIST_VIEW_START_DATE = 'FILTERS:SET_LIST_VIEW_START_DATE';
export const SET_LIST_VIEW_END_DATE = 'FILTERS:SET_LIST_VIEW_END_DATE';
export const SET_LIST_VIEW_PAGE_NUM = 'FILTERS:SET_LIST_VIEW_PAGE_NUM';
export const SET_SEARCH_PARAM = 'FILTERS:SET_SEARCH_PARAM';

/**
 * Set Filters
 */
export const SET_VIEWFILTER_SUCCESS = 'VIEWFILTER:SET_VIEWFILTER_SUCCESS';
export const SET_VIEWFILTER_FAILURE = 'VIEWFILTER:SET_VIEWFILTER_FAILURE';
export const SET_VIEWFILTER = 'VIEWFILTER:SET_VIEWFILTER';
export const SET_REFINEDFILTER_SUCCESS =
    'REFINEDFILTER:SET_REFINEDFILTER_SUCCESS';
export const SET_REFINEDFILTER_FAILURE =
    'REFINEDFILTER:SET_REFINEDFILTER_FAILURE';
export const SET_REFINEDFILTER = 'REFINEDFILTER:SET_REFINEDFILTER';

/**
 * Get Filters from backend
 */
export const GET_APPLIED_FILTERS = 'VIEWFILTER:GET_APPLIED_FILTERS';
export const GET_APPLIED_FILTERS_SUCCESS =
    'VIEWFILTER:GET_APPLIED_FILTERS_SUCCESS';
export const GET_APPLIED_FILTERS_FAILURE =
    'VIEWFILTER:GET_APPLIED_FILTERS_FAILURE';

export const GET_VIEWFILTER = 'VIEWFILTER:GET_VIEWFILTER';
export const GET_VIEWFILTER_SUCCESS = 'VIEWFILTER:GET_VIEWFILTER_SUCCESS';
export const GET_VIEWFILTER_FAILURE = 'VIEWFILTER:GET_VIEWFILTER_FAILURE';
export const GET_REFINEDFILTER = 'REFINEDFILTER:GET_REFINEDFILTER';
export const GET_REFINEDFILTER_SUCCESS =
    'REFINEDFILTER:GET_REFINEDFILTER_SUCCESS';
export const GET_REFINEDFILTER_FAILURE =
    'REFINEDFILTER:GET_REFINEDFILTER_FAILURE';

export const PUT_FILTEROPTION_SUCCESS = 'FILTEROPTION:PUT_FILTEROPTION_SUCCESS';
export const PUT_FILTEROPTION_FAILURE = 'FILTEROPTION:PUT_FILTEROPTION_FAILURE';
export const PUT_FILTEROPTION = 'FILTEROPTION:PUT_FILTEROPTION';

export const RESET_CALENDAR_FILTERS = 'CALENDAR:RESET_CALENDAR_FILTERS';
export const RESET_CALENDAR_FILTERS_SUCCESS =
    'CALENDAR:RESET_CALENDAR_FILTERS_SUCCESS';
export const RESET_CALENDAR_FILTERS_FAILURE =
    'CALENDAR:RESET_CALENDAR_FILTERS_FAILURE';

export const GET_PHYSICIANS_SUCCESS = 'PHYSICIANS:GET_PHYSICIANS_SUCCESS';
export const GET_PHYSICIANS_FAILURE = 'PHYSICIANS:GET_PHYSICIANS_FAILURE';
export const GET_PHYSICIANS = 'PHYSICIANS:GET_PHYSICIANS';

export const GET_SURGERYPREVIEW_SUCCESS =
    'SURGERYPREVIEW:GET_SURGERYPREVIEW_SUCCESS';
export const GET_SURGERYPREVIEW_FAILURE =
    'SURGERYPREVIEW:GET_SURGERYPREVIEW_FAILURE';
export const GET_SURGERYPREVIEW = 'SURGERYPREVIEW:GET_SURGERYPREVIEW';

export const GET_PROCEDURES = 'PROCEDURES:GET_PROCEDURES';
export const GET_PROCEDURES_SUCCESS = 'PROCEDURES:GET_PROCEDURES_SUCCESS';
export const GET_PROCEDURES_FAILURE = 'PROCEDURES:GET_PROCEDURES_FAILURE';

export const GET_USERPROFILE_SUCCESS = 'USERPROFILE:GET_USERPROFILE_SUCCESS';
export const GET_USERPROFILE_FAILURE = 'USERPROFILE:GET_USERPROFILE_FAILURE';
export const GET_USERPROFILE = 'USERPROFILE:GET_USERPROFILE';

export const GET_PAGEVISIBILITYRULE_SUCCESS =
    'PAGEVISIBILITYRULE:GET_PAGEVISIBILITYRULE_SUCCESS';
export const GET_PAGEVISIBILITYRULE_FAILURE =
    'PAGEVISIBILITYRULE:GET_PAGEVISIBILITYRULE_FAILURE';
export const GET_PAGEVISIBILITYRULE =
    'PAGEVISIBILITYRULE:GET_PAGEVISIBILITYRULE';
export const SET_ACTIVE_NAV_LINK = 'NAV_LINK:SET_ACTIVE_NAV_LINK';
export const RESET_APPLIED_FILTERS_UPDATED =
    'FILTERS:RESET_APPLIED_FILTERS_UPDATED';

export const SET_SHOW_FILTER_RESULTS_PANEL =
    'FILTERS:SET_SHOW_FILTER_RESULTS_PANEL';

export const GET_CARD_PREVIEW_DETAILS = 'GET_CARD_PREVIEW_DETAILS';

export const GET_CARD_PREVIEW_DETAILS_SUCCESS =
    'GET_CARD_PREVIEW_DETAILS_SUCCESS';

export const GET_CARD_PREVIEW_DETAILS_FAILURE =
    'GET_CARD_PREVIEW_DETAILS_FAILURE';

export const CLOSE_PREVIEW_DETAILS_MODAL = 'CLOSE_PREVIEW_DETAILS_MODAL';

export const SET_ORDER_CONDTION = 'SET_ORDER_CONDTION';

export const RESET_FILTER_DATA_AFTER_IMPERSONATION =
    'RESET_FILTER_DATA_AFTER_IMPERSONATION';

export const setActiveNavLink = (payload) => {
    return {
        type: SET_ACTIVE_NAV_LINK,
        payload: payload,
    };
};

export const getViewData = (filter) => {
    return {
        type: GET_VIEW_DATA,
        payload: filter,
    };
};

export const setViewDataEmpty = () => {
    return {
        type: SET_VIEW_DATA_EMPTY,
        payload: [],
    };
};

export const getCardData = (filter) => {
    return {
        type: GET_CARD_DATA,
        payload: filter,
    };
};

export const getSearchCardData = (filter) => {
    return {
        type: GET_SEARCH_CARD_DATA,
        payload: filter,
    };
};

export const getListData = (filter) => {
    return {
        type: GET_LIST_DATA,
        payload: filter,
    };
};
export const getAppliedFilters = (filters) => {
    return {
        type: GET_APPLIED_FILTERS,
        payload: filters,
    };
};

export const getRefinedFilters = (filter) => {
    return {
        type: GET_REFINEDFILTER,
        payload: filter,
    };
};
export const getViewFilter = (filter) => {
    return {
        type: GET_VIEWFILTER,
        payload: filter,
    };
};
export const putFilterOptions = (filter) => {
    return {
        type: PUT_FILTEROPTION,
        payload: filter,
    };
};
export const resetCalendarFilters = (filters) => {
    return {
        type: RESET_CALENDAR_FILTERS,
        payload: filters,
    };
};
export const setFilters = (filter) => {
    return {
        type: SET_FILTERS,
        payload: filter,
    };
};
export const setViewFilter = (value) => {
    return {
        type: SET_VIEWFILTER,
        payload: value,
    };
};
export const getPhysicians = (filter) => {
    return {
        type: GET_PHYSICIANS,
        payload: filter,
    };
};

export const getSurgeryPreview = (filter) => {
    return {
        type: GET_SURGERYPREVIEW,
        payload: filter,
    };
};

export const getProcedures = (filter) => {
    return {
        type: GET_PROCEDURES,
        payload: filter,
    };
};

export const getUserProfile = () => {
    return {
        type: GET_USERPROFILE,
    };
};

export const getPageVisibilityRule = (filter) => {
    return {
        type: GET_PAGEVISIBILITYRULE,
        payload: filter,
    };
};

export const setVisibleDateRange = (dateRange) => {
    return {
        type: SET_VISIBLE_DATE_RANGE,
        payload: dateRange,
    };
};

export const setSurgeryDates = (dates) => {
    return {
        type: SET_SURGERY_DATES,
        payload: dates,
    };
};

export const setSelectedDate = (date) => {
    return {
        type: SET_SELECTED_DATE,
        payload: date,
    };
};

export const setCalendarView = (view) => {
    return {
        type: CALENDAR_VIEW,
        payload: view,
    };
};

export const setFilterPopoverOpen = (isFilterOpen) => {
    return {
        type: OPEN_FILTERS,
        payload: isFilterOpen,
    };
};

export const setSelectedCalendarView = (view) => {
    return {
        type: SET_SELECTED_CALENDAR_VIEW,
        payload: view,
    };
};

export const setActionItemsOnly = (actionItemsOnly) => {
    return {
        type: SET_ACTION_ITEMS_ONLY,
        payload: actionItemsOnly,
    };
};

export const setExpandedFilterViews = (expandedFilterViews) => {
    return {
        type: SET_EXPANDED_FILTER_VIEWS,
        payload: expandedFilterViews,
    };
};

export const setListViewStartDate = (date) => {
    return {
        type: SET_LIST_VIEW_START_DATE,
        payload: date,
    };
};

export const setListViewEndDate = (date) => {
    return {
        type: SET_LIST_VIEW_END_DATE,
        payload: date,
    };
};

export const setListViewPageNum = (pageNum) => {
    return {
        type: SET_LIST_VIEW_PAGE_NUM,
        payload: pageNum,
    };
};

export const setSearchParam = (searchParam) => {
    return {
        type: SET_SEARCH_PARAM,
        payload: searchParam,
    };
};

export const resetAppliedFilterUpdatedFlag = () => {
    return {
        type: RESET_APPLIED_FILTERS_UPDATED,
    };
};

export const setShowFiltersResultsPanel = (showFilterResultsPanel) => {
    return {
        type: SET_SHOW_FILTER_RESULTS_PANEL,
        payload: showFilterResultsPanel,
    };
};

export const getCardPreviewDetails = (previewObj) => {
    return {
        type: GET_CARD_PREVIEW_DETAILS,
        payload: previewObj,
    };
};
export const closePreviewDetails = (orderPreviewState) => {
    return {
        type: CLOSE_PREVIEW_DETAILS_MODAL,
        payload: orderPreviewState,
    };
};
export const resetCalendarSelectedDate = () => {
    return {
        type: RESET_SELECTED_DATE,
    };
};
export const setOrderCondition = (data) => {
    return {
        type: SET_ORDER_CONDTION,
        payload: data,
    };
};
export const resetCalendarFilterDataAfterImpersonation = () => {
    return {
        type: RESET_FILTER_DATA_AFTER_IMPERSONATION,
    };
};
